import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { keyframes } from "@emotion/react";
import clsx from "clsx";
import { Svg } from "./Svg";
import { useTheme } from "./ThemeProvider";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const circularLoadingClasses = {
    root: "MinervaCircularLoading-root",
    background: "MinervaCircularLoading-background",
    progress: "MinervaCircularLoading-progress",
};
export const CircularLoading = (props) => {
    const { size = "lg", color = "primary", colorSet, invertColors, sx, className, ...rest } = useDefaultProps({ props, component: "CircularLoading" });
    const indeterminateKeyframe = keyframes `
      0% {
        stroke-dasharray: 0 200;
        stroke-dashoffset: 0;
        transform: rotate(0);
      }
    
      50% {
         stroke-dasharray: 100 200;
         stroke-dashoffset: -15;
         transform: rotate(180deg);
      }
    
      100% {
         stroke-dasharray: 100 200;
         stroke-dashoffset: -125;
         transform: rotate(360deg);
      }
    `;
    const theme = useTheme();
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: ({ background }) => {
            return (_jsxs(Svg, { size: typeof size === "string" ? size : undefined, width: typeof size === "number" ? size : undefined, height: typeof size === "number" ? size : undefined, viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg", fill: "none", className: clsx([circularLoadingClasses.root, className]), sx: mergeSx({
                    [`& .${circularLoadingClasses.progress}`]: {
                        animation: `${indeterminateKeyframe} 2s linear infinite`,
                        transformOrigin: "center",
                    },
                }, sx), ...rest, children: [_jsx("circle", { cx: 25, cy: 25, r: 20, fill: "none", stroke: theme.palette.disabled.main, strokeWidth: 5, className: circularLoadingClasses.background }), _jsx("circle", { cx: 25, cy: 25, r: 20, fill: "none", stroke: background, strokeWidth: 5, className: circularLoadingClasses.progress })] }));
        } }));
};
//# sourceMappingURL=CircularLoading.js.map